import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home"
import Legacy from "./components/pages/Legacy"
import Footer from './components/Footer'
import Teeshirt from "./components/pages/Teeshirt";
import Login from "./components/pages/Login";
import AdminDashboard from "./components/pages/AdminDashboard";
import SubmitEvent from "./components/pages/SubmitEvent";
import ProtectedRoute from "./components/ProtectedRoute";
import { Routes, Route, useLocation } from 'react-router-dom'

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname === '/login';

  return (
    <>
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tee-shirt" element={<Teeshirt/>}/>
        <Route path="/legacy" element={<Legacy />} />
        <Route path="/soumettre-votive" element={<SubmitEvent />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
}

export default App;
